<template>
  <v-dialog v-model="dialogOpen" max-width="820" scrollable>
    <v-card dir="rtl">
      <v-card-title class="rb-legal-dialog-title">شرایط استفاده و حریم خصوصی</v-card-title>
      <v-card-text class="rb-legal-dialog-body">
        <nav class="rb-legal-tabs" aria-label="انتخاب سند">
          <button v-for="id in ['terms', 'privacy']" :key="id" type="button" :aria-pressed="activeDocumentId === id" @click="activeDocumentId = id">{{ titles[id] }}</button>
        </nav>
        <legal-document :document-id="activeDocumentId"/>
      </v-card-text>
      <v-card-actions>
        <v-btn text color="primary" @click="dialogOpen = false">بستن</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LegalDocument from '@/components/legal/LegalDocument.vue'

export default {
  name: 'LegalDocumentsDialog',
  components: {LegalDocument},
  props: {value: {type: Boolean, default: false}, documentId: {type: String, default: 'terms'}},
  data() {return {activeDocumentId: this.documentId === 'privacy' ? 'privacy' : 'terms', titles: {terms: 'شرایط استفاده', privacy: 'حریم خصوصی'}}},
  computed: {
    dialogOpen: {get() {return this.value}, set(value) {this.$emit('input', value)}},
  },
  watch: {
    documentId(value) {this.activeDocumentId = value === 'privacy' ? 'privacy' : 'terms'},
    value(open) {if (open) this.activeDocumentId = this.documentId === 'privacy' ? 'privacy' : 'terms'},
  },
}
</script>

<style scoped>
.rb-legal-dialog-title{white-space:normal;word-break:normal;line-height:1.8}
.rb-legal-dialog-body{padding-top:12px!important;max-height:70vh}
.rb-legal-tabs{display:flex;gap:10px;flex-wrap:wrap;margin:0 0 24px}
.rb-legal-tabs button{padding:8px 14px;border:1px solid #16a3a0;border-radius:8px;font:inherit;color:#173e50}
.rb-legal-tabs button[aria-pressed="true"]{background:#eaf8f6;font-weight:bold}
</style>
